import styled from "styled-components";
import { CSSProperties } from "react";
export const Container = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 10% 90% / 100%;
`;

export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

export const ContainerModalArquivo = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-left: 3px solid black;
  border-right: 3px solid black;
  border-bottom: 3px solid black;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: #f0f4f7;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const formStyle: CSSProperties = {
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  borderTop: "3px solid black",
  borderLeft: "3px solid black",
  borderRight: "3px solid black",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  backgroundColor: "#f0f4f7",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
};
export const formStyle2: CSSProperties = {
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  border: "3px solid black",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  backgroundColor: "#f0f4f7",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
};

export const TextModal = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #3a3a3a;
  margin-left: 15px;
`;

export const layout = {
  //Layout que altera o tamanho e a posição dos nomes e labels dos formulários de : Empreendimentos,Especificações de Apto,Cadastrar Apartamento,AtualizarCadastro,CadastroProprietario
  labelCol: { span: 10 },
  wrapperCol: { span: 10 },
};
